import styledC from 'styled-components';

import theme from '@adsk/alloy-react-theme';

const MenuGroupHeader = styledC.p`
  display: flex;
  align-items: center;
  margin: 0px;
  padding-left: ${theme.spacing.M}px;
  height: 32px;
  background: ${theme.tokens.colors.background.secondary.value};
  color: inherit;
  ${theme.typography.bodySmall}
`;

MenuGroupHeader.displayName = 'MenuGroupHeader';

export default MenuGroupHeader;
